<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
    <el-form-item label="通知内容">
      <el-input
        type="textarea"
        v-model="ruleForm.SettingContent"
        :rows="10"
        style="width: 79rem"
      ></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ZjComponentAPPDetail",
  controller: "UI",
  action: "ComponentAPPDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
  },
  data() {
    return {
      ruleForm: {
        SettingContent: "",
      },
    };
  },
  created: function () {
    this.search();
  },
  methods: {
    showLoading(text) {
      this.$emit("loading", text);
    },
    hideLoading() {
      this.$emit("loadingFinish");
    },
    search() {
      let PlanTaskId = this.$props.PlanTaskId;
      //let TaskSubTypeId=this.$props.TaskSubTypeId;
      if (PlanTaskId != null && PlanTaskId != "") {
        let searchInfo = {
          PlanTaskId: PlanTaskId,
          TaskSubTypeId: this.TaskSubTypeId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        this.showLoading("加载中...");
        new MyApis.PlantasksettingApi()
          .FindByConditions(searchInfo)
          .then((r) => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.ruleForm = data[0];
              this.hideLoading();
            } else {
              this.hideLoading();
            }
          })
          .catch((e) => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.hideLoading();
          });
      }
    },
    Gettaskreceiver() {
      var tasksett = {};

      tasksett.OrgId = this.user.Departments[0].OrgId;
      //tasksett.SettingId = utils.uuid();
      tasksett.PlanTaskId = this.PlanTaskId;
      tasksett.SettingContent = this.ruleForm.SettingContent;
      tasksett.TaskSubTypeId = this.TaskSubTypeId;

      return { TaskSettingDTO: tasksett, TaskReceiverDTO: [] };
    },
  },
};
</script>